<template>
    <div style="position: relative">
        <div style="position: absolute;left: 20px;top: 10px;z-index: 999999">
            <Language/>
        </div>
        <div class="container-fluid p-0">
            <div class="row m-0">
                <div class="col-xl-7 b-center bg-size p-0"
                     :style="{ backgroundImage: 'url('+ require('../assets/images/login/1.jpg') +')' }"
                     style="background-size: cover; background-position: center center; display: block;">
                </div>
                <div class="col-xl-5 p-0">
                    <div class="login-card">
                        <div>
                            <div>
                                <a class="logo" target="_blank" href="https://www.gameofbusiness.eu/">
                                    <img
                                            class="img-fluid for-light"
                                            src="../assets/images/logo/logo.png"
                                            alt="looginpage"
                                    />
                                </a>
                            </div>
                            <div class="login-main login-form-card">
                                <form class="theme-form" @submit.stop="" novalidate>
                                    <h4>{{ $t("message.register_create_account") }}</h4>
                                    <p>{{ $t("message.register_create_account_subtitle") }}</p>
                                    <div class="form-group">
                                        <label class="col-form-label pt-0">{{
                                            $t("message.register_your_name_label")
                                            }}</label>
                                        <div class="form-row">
                                            <div class="col-6">
                                                <input
                                                        v-model="fname"
                                                        v-validate.disable="'required'"
                                                        class="form-control"
                                                        type="text"
                                                        required=""
                                                        :placeholder="$t('message.register_first_name')"
                                                        name="fname"
                                                />
                                                <span class="error-red mt-4"
                                                      v-if="errors.first('fname')">{{
                                                    $t('message.register_error_f_name')
                                                    }}</span>
                                            </div>
                                            <div class="col-6">
                                                <input
                                                        v-model="lname"
                                                        v-validate.disable="'required'"
                                                        class="form-control"
                                                        type="text"
                                                        required=""
                                                        :placeholder="$t('message.register_last_name')"
                                                        name="lname"
                                                />
                                                <span class="error-red mt-4"
                                                      v-if="errors.first('lname')">{{
                                                    $t('message.register_error_l_name')
                                                    }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-form-label">{{ $t('message.register_email_label') }}</label>

                                        <div style="position: relative">

                                            <input
                                                    v-model="email"
                                                    v-validate.disable="'required|email'"
                                                    class="form-control"
                                                    type="email"
                                                    required=""
                                                    placeholder="Test@gmail.com"
                                                    name="email"
                                            />
                                            <span class="error-red mt-4" v-if="errors.first('email')">{{
                                                $t("message.register_error_email")
                                                }}</span>

                                        </div>

                                    </div>
                                    <div class="form-group">
                                        <label class="col-form-label">{{ $t("message.register_password") }}
                                            <b-button id="html-tooltip-top"
                                                      style="border: none !important;background: none !important;padding:0px;color: black">
                                                <i
                                                        class="fa fa-question-circle"></i></b-button>
                                            <b-tooltip target="html-tooltip-top" triggers="hover" placement="top">
                                                {{ $t("message.register_password_tooltip") }}
                                            </b-tooltip>
                                        </label>

                                        <div style="position: relative">

                                            <svg @click="showPass = true" v-if="!showPass"
                                                 style="cursor:pointer;position:absolute;right: 10px;top: 50%;transform: translateY(-50%);width: 20px;"
                                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                 stroke-width="1.5" stroke="currentColor" class="w-6 h-6 ">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/>
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                            </svg>

                                            <svg @click="showPass = false" v-if="showPass"
                                                 style="cursor:pointer;position:absolute;right: 10px;top: 50%;transform: translateY(-50%);width: 20px;"
                                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                 stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
                                            </svg>


                                            <input
                                                    v-model="password"
                                                    v-validate.disable="{
                                    required: true,
                                    min: 8,
                                    regex: /^\S*(?=\S{8,})(?=\S*[a-z])(?=\S*[A-Z])(?=\S*[\d])(?=\S*[\W])\S*$/
                                }"
                                                    class="form-control"
                                                    :type="showPass ? 'text' : 'password'"
                                                    name="password"
                                                    required=""
                                                    placeholder="*********"
                                            />
                                        </div>


                                        <span class="error-red mt-4" v-if="errors.first('password')">
                      {{ $t("message.register_error_password") }}
                    </span>
                                    </div>

                                    <div>
                                        <div v-for="(page, index) in confirmations" :key="page.id">
                                            <input
                                                    v-validate="'required'"
                                                    v-model="page.checked"
                                                    class="mr-2"
                                                    :name="'check_' + index"
                                                    required
                                                    type="checkbox"
                                            />

                                            <label>
                                                <router-link :to="{ name: 'SinglePage', params: {slug: page.slug}}"
                                                             target="_blank">
                                                    {{ page.title }}
                                                </router-link>
                                            </label>

                                            <div class="error-red" style="margin-top: -10px;margin-bottom: 10px;"
                                                 v-show="errors.has('check_' + index)">
                                                {{ $t("message.please_conform") }}
                                            </div>

                                        </div>
                                    </div>


                                    <div class="form-group mb-0">
                                        <button class="btn btn-primary btn-block" type="submit"
                                                @click.stop.prevent="register">
                                            {{ $t("message.register_create") }}
                                        </button>
                                    </div>

                                    <p class="mt-4 mb-0">
                                        {{ $t("message.register_login_label") }}
                                        <router-link class="ml-2" tag="a" to="/auth/login">
                                            {{ $t("message.register_login") }}
                                        </router-link>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Language from './../components/header/language';

export default {
    components: {
        Language
    },
    data: function () {
        return {
            fname: "",
            lname: "",
            email: "",
            password: "",
            confirmations: [],
            showPass: false
        };
    },
    created() {
        this.loadPages()
    },
    methods: {

        getTitle(translations) {
            return translations[0].name
        },

        async loadPages() {

            let response = await this.$store.dispatch('shared/getPages')

            let pages = response.data.result.filter((item) => {
                return item.in_registration
            })

            pages.forEach((item) => {
                this.confirmations.push({
                    title: this.getTitle(item.translation),
                    slug: item.slug,
                    checked: false,
                })
            })
        },

        async register() {

            this.$validator.validate().then(valid => {

                if (valid) {

                    try {

                        this.$store.dispatch("shared/signUp", {
                            name: this.fname + ' ' + this.lname,
                            email: this.email,
                            password: this.password,
                        }).then((responce) => {
                            this.$router.push({name: 'Home'})
                        })

                    } catch (error) {
                        console.log(error)
                    }
                }
            })
        }
    }
};
</script>
